import { SearchDataStructure, AttributeTypes } from '../ui/components';
import { KPIData } from '../pages/admin/kpi-setup';
import { CoachData } from '../pages/admin/coach-setup';

const mockDataSingleOption: SearchDataStructure[] = [
  {
    name: 'Attribute Name',
    key: 'attributeName',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'productId',
        value: 'productId',
      },
      {
        key: 'aliasCode',
        value: 'aliasCode',
      },
    ],
  },
  {
    name: 'Attribute Value',
    key: 'attributeValue',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Language',
    key: 'language',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: false,
    dataset: [
      {
        key: 'en',
        value: 'English',
      },
      {
        key: 'th',
        value: 'Thai',
      },
    ],
  },
];
const mockDataUserSingleOption: SearchDataStructure[] = [
  {
    name: 'Login ID',
    key: 'loginId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Name',
    key: 'name',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Email',
    key: 'email',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Phone Number',
    key: 'phone',
    type: AttributeTypes.TextboxNumber,
    labelInfo: 'Exclude country code',
    visibility: false,
  },
  // {
  //   name: 'Role',
  //   key: 'role',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: false,
  //   dataset: [
  //     {
  //       key: 'ADMIN',
  //       value: 'Admin',
  //     },
  //     {
  //       key: 'MEMBER',
  //       value: 'Member',
  //     },
  //   ],
  // },
  // {
  //   name: 'Member Type',
  //   key: 'memberType',
  //   type: AttributeTypes.DropdownMultiSelect,
  //   visibility: false,
  //   allSelectionOption: true,
  //   dataset: [
  //     {
  //       key: 'INDIVIDUAL',
  //       value: 'INDIVIDUAL',
  //     },
  //     {
  //       key: 'COUPLE',
  //       value: 'COUPLE',
  //     },
  //     {
  //       key: 'INDIVIDUAL_INVISIBLE',
  //       value: 'INDIVIDUAL_INVISIBLE',
  //     },
  //   ],
  // },
  // {
  //   name: 'User ID',
  //   key: 'userId',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
  // {
  //   name: 'Primary User',
  //   key: 'isPrimary',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: false,
  //   dataset: [
  //     {
  //       key: 'true',
  //       value: 'True',
  //     },
  //     {
  //       key: 'false',
  //       value: 'False',
  //     },
  //   ],
  // },
];
const campaignSearchOptions: SearchDataStructure[] = [
  {
    name: 'Campaign ID',
    key: 'campaignId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Campaign Name',
    key: 'campaignName',
    type: AttributeTypes.Textbox,
    visibility: false,
  },
  {
    name: 'Campaign Type',
    key: 'campaignType',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'challenge',
        value: 'CHALLENGE',
      },
      {
        key: 'promotion',
        value: 'PROMOTION',
      },
    ],
  },
];
const mockDataMultipleOptions = [
  {
    name: 'Product id',
    key: 'product_id',
    type: 'textbox_numeric',
    visibility: true,
  },
  {
    name: 'Product Name',
    key: 'product_name',
    type: 'textbox',
    visibility: true,
  },
  {
    name: 'Testing Name',
    key: 'testing_name',
    type: 'textbox',
    visibility: true,
  },
  {
    name: 'Testing id',
    key: 'testing_id',
    type: 'textbox_numeric',
    visibility: false,
  },
  {
    name: 'Channel',
    key: 'channel',
    type: 'dropdown',
    visibility: true,
    dataset: [
      {
        key: 'web',
        value: 'Web',
      },
      {
        key: 'mobile',
        value: 'Mobile',
      },
    ],
  },
  {
    name: 'From date',
    key: 'fromdate',
    type: 'datetime_single',
    minDate: '01/05/2023',
    maxDate: '31/05/2023',
    visibility: false,
  },
  {
    name: 'Date Range',
    key: 'range_date',
    type: 'datetime_range',
    minDate: '01/05/2023',
    maxDate: '31/05/2023',
    visibility: false,
  },
];

// Story demo

const productStatusArray = ['Published', 'Staging'];

const productListMockEntry = () => ({
  productId: 'p0001',
  aliasCode: 1234,
  productName: 'XS Protein Pods - Choclate',
  channel: 'DEFAULT',
  vertical: 'Default',
  language: 'EN',
  createdDate: new Date('2023-03-03T00:00:00Z'),
  updatedDate: new Date('2023-03-05T00:00:00Z'),
  status: productStatusArray[Math.floor(Math.random() * productStatusArray.length)],
});

const productListMock = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(() => productListMockEntry());

const userListMockEntry = (index: number) => {
  const userId = (index + 1).toString();
  const loginId = `ABO-${userId.toString().padStart(2, '0')}`;
  const role = Math.random() < 0.5 ? 'ADMIN' : 'MEMBER';
  const memberTypes = ['INDIVIDUAL', 'COUPLE', 'INDIVIDUAL_INVISIBLE'];
  const memberType = memberTypes[Math.floor(Math.random() * memberTypes.length)];
  const isPrimary = (Math.random() < 0.5).toString();
  const names = ['John', 'Jane', 'Bob', 'Alice', 'Charlie', 'Diana', 'Eva', 'Frank', 'Grace', 'Harry'];
  const name = names[Math.floor(Math.random() * names.length)];

  return {
    userId,
    loginId,
    role,
    memberType,
    isPrimary,
    name,
  };
};

const userListMock = Array.from({ length: 15 }, (_, index) => userListMockEntry(index));

const kpiListMock: KPIData[] = [
  {
    action: 'WEIGHT_IN',
    kpiCode: 'WEIGHT_IN_TEAM',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'TEAM',
    itemId: '',
    status: 'ACTIVE',
  },
  {
    action: 'WEIGHT_OUT',
    kpiCode: 'WEIGHT_OUT_TEAM',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'TEAM',
    itemId: '',
    status: 'ACTIVE',
  },
  {
    action: 'WEIGHT_IN',
    kpiCode: 'NEW_ABO_TEAM',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'TEAM',
    itemId: '',
    status: 'ACTIVE',
  },
  {
    action: 'WEIGHT_OUT',
    kpiCode: 'WIEGHT_ACHIEVEMENT_TEAM',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'TEAM',
    itemId: '',
    status: 'ACTIVE',
    subKpi: [
      {
        recId: 1,
        no: 1,
        subKPICode: 'WEIGHT_LOST',
        description: '',
      },
      {
        recId: 2,
        no: 2,
        subKPICode: 'BODY_FAT_LOST',
        description: '',
      },
      {
        recId: 3,
        no: 3,
        subKPICode: 'MUSCLE_MASS_GAIN',
        description: '',
      },
    ],
  },
  {
    action: 'WEIGHT_OUT',
    kpiCode: 'WIEGHT_ACHIEVEMENT_INDIVIDUAL',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'INDIVIDUAL',
    itemId: '',
    status: 'ACTIVE',
    subKpi: [
      {
        recId: 4,
        no: 1,
        subKPICode: 'WEIGHT_LOST',
        description: '',
      },
      {
        recId: 5,
        no: 2,
        subKPICode: 'BODY_FAT_LOST',
        description: '',
      },
      {
        recId: 6,
        no: 3,
        subKPICode: 'MUSCLE_MASS_GAIN',
        description: '',
      },
    ],
  },
  {
    action: 'PURCHASE',
    kpiCode: 'PURCHASE_STARTKIT',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
    subKpi: [
      {
        recId: 7,
        no: 1,
        subKPICode: 'PURCHASE_BODYKEY',
        description: '',
      },
      {
        recId: 8,
        no: 2,
        subKPICode: 'PURCHASE_GUTFIT_PACK',
        description: '',
      },
      {
        recId: 9,
        no: 3,
        subKPICode: 'PURCHASE_GUTFIT_BYO',
        description: '',
      },
    ],
  },
  {
    action: 'PURCHASE',
    kpiCode: 'SUBSCRIBE_ALP',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
  },
  {
    action: 'WEIGHT_IN',
    kpiCode: 'WEIGHT_IN',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
  },
  {
    action: 'WEIGHT_OUT',
    kpiCode: 'WEIGHT_OUT',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
  },
  {
    action: 'WEIGHT_OUT',
    kpiCode: 'WEIGHT_ACHIEVEMENT_UPLINE',
    description: '',
    enrollmentType: 'PARTICIPANT',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
    subKpi: [
      {
        recId: 10,
        no: 1,
        subKPICode: 'WEIGHT_LOST',
        description: '',
      },
      {
        recId: 11,
        no: 2,
        subKPICode: 'BODY_FAT_LOST',
        description: '',
      },
      {
        recId: 12,
        no: 3,
        subKPICode: 'MUSCLE_MASS_GAIN',
        description: '',
      },
    ],
  },
  {
    action: '',
    kpiCode: 'QUALIFIED_TEAM_COUNT',
    description: '',
    enrollmentType: 'COACH',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
    subKpi: [
      {
        recId: 13,
        no: 1,
        subKPICode: 'REQUIRED_TEAM_POINTS',
        description: '',
      },
      {
        recId: 14,
        no: 2,
        subKPICode: 'REQUIRED_TEAM_NEW_ABO',
        description: '',
      },
    ],
  },
  {
    action: '',
    kpiCode: 'QUALIFIED_COACH',
    description: '',
    enrollmentType: 'LEADER',
    kpiType: 'POINT',
    itemId: '',
    status: 'ACTIVE',
  },
].map((kpi, i) => ({ ...kpi, recId: i + 1 }));

const coachListMock: CoachData[] = [
  {
    coachID: 'C001',
    aboID: 'ABO001',
    name: 'John Doe',
    contact: '+60 1234567890',
    email: 'john.doe@example.com',
    remark: 'John Profile',
    status: 'ACTIVE',
  },
  {
    coachID: 'C002',
    aboID: 'ABO002',
    name: 'Jane Smith',
    contact: '+60 9876543210',
    email: 'jane.smith@example.com',
    remark: 'Jane Profile',
    status: 'ACTIVE',
  },
  {
    coachID: 'C003',
    aboID: 'ABO003',
    name: 'Bob Johnson',
    contact: '+60 1122334455',
    email: 'bob.johnson@example.com',
    remark: 'Bob Profile',
    status: 'ACTIVE',
  },
  {
    coachID: 'C004',
    aboID: 'ABO004',
    name: 'Alice Williams',
    contact: '+65 9876543210',
    email: 'alice.williams@example.com',
    remark: 'Allice Profile',
    status: 'ACTIVE',
  },
  {
    coachID: 'C005',
    aboID: 'ABO005',
    name: 'Charlie Davis',
    contact: '+65 1122334455',
    email: 'charlie.davis@example.com',
    remark: '',
    status: 'INACTIVE',
  },
].map((coach, i) => ({ ...coach, recId: i + 1 }));

export {
  mockDataSingleOption,
  mockDataMultipleOptions,
  productListMock,
  productStatusArray,
  userListMock,
  mockDataUserSingleOption,
  kpiListMock,
  coachListMock,
  campaignSearchOptions,
};
